<template>
  <div class="csong">
    <div class="csongbg">
      <appHeader activeIndex="csong" ></appHeader>
      <div class="csongContent">
        <!-- 介绍 -->
        <div class="csongInfo">
          <div class="csongInfo1">
            <img class="csongInfo1Img1" src="../../assets/img/Product/csong.png"  alt />
            <br>
            <!-- <img class="csongInfo1Img2"  src="../../assets/img/products/csong/csongQRcode.png" alt />
            <div>扫描二维码下载</div>      -->
          </div>
          <div class="csongInfo2">
            <img src="../../assets/img/products/csong/csongFont.png" alt />
             <el-divider></el-divider>
             <h2>应用介绍</h2>
             <p>多多儿歌：听儿歌、听故事、学国学，就用多多儿歌！</p>
             <p>【童心有梦 儿歌陪伴】没有哪个孩子的幼年不需要儿歌的陪伴，儿歌多多为宝宝提供超多类型的歌曲，包括：经典儿歌、英文儿歌、儿歌串烧、正能量、小动物等多种类型！每首儿歌都支持免费下载、收藏！</p>
             <p>【声临其境 启蒙故事】经常听故事的孩子，想象力都非常丰富。故事也是孩子睡前必备的要求！那么，你可以选择给孩子听：睡前故事、童话故事、寓言故事、幼儿好习惯等各种故事，让孩子在故事中获得启蒙！</p>
             <p>【古诗古韵 国学熏陶】中国的宝宝，一定要学习国学！了解中国历史博大精深的文化底蕴！像必背古诗词、国学经典、唐诗、古词，都是宝宝们要掌握的知识哦！</p>
             <p>【定时设置 随意播放】我们为您提供定时关闭的功能，更好的合理安排宝宝使用APP时间，保护宝宝的眼睛。支持单曲循环和顺序播放，人性化设计贴合您的使用感受！</p>
             <p>【免费收藏 免费下载】无论是儿歌、故事，还是国学，全部支持免费收藏和免费下载，给予宝宝更多学习空间，让宝宝爱上学习！
多多儿歌，不只听儿歌，还有故事和国学！</p>
          </div>
          <div style="clear: both;"></div> 
        </div>
        <!-- 第二部分内容  -->
        <el-divider></el-divider>
        <div class="csongCarousel">
          <div class="iconLeft" @click="left"><el-button icon="el-icon-arrow-left" circle></el-button></div>
          <div class="iconRight" @click="right"><el-button icon="el-icon-arrow-right" circle></el-button></div>
          <div class="csongWrap">
            <div class="csongMainImg" :style="{ left: nowLeft + '%' }">
              <img class="csongCarouselImg"   src="../../assets/img/products/csong/carousel.png" alt />
            </div>
          </div>
          
        </div>
      </div>
    </div>
    <appFooter></appFooter>

  </div>
</template>
 
<script>
import appHeader from "../components/Header";
import appFooter from "../components/Footer";
export default {
  components: {
    appHeader,appFooter
  },
  data() {
    return {
      nowLeft: 0
    };
  },
  mounted() {},
  methods: {
    
      left() {
        
        if(this.nowLeft >= 0){
          return;
        }
        this.nowLeft = this.nowLeft +15
      },

      right() {
        if(this.nowLeft <= -45){
          return;
        }
        this.nowLeft = this.nowLeft -15
      }
  }
};
</script>
<style>
@import "../../assets/css/products/csong.css";
</style>
